import React, { useState, useEffect, useContext } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Slider from "react-slick";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";
import URLstateContext from "../../../provider/CommonContext";
import {
  GetMethodData,
  GetPostMethodData,
  DecryptAESdata,
} from "../../../provider/ServiceProvider";
import { event } from "jquery";
import animation from "../../../images/jm-animation.gif";
import { Modal } from "react-bootstrap";
import { AiFillCloseCircle } from 'react-icons/ai';
import '../OurFundInner/OurFundInner.css'
function OurFundInner() {
  const [FetchData, SetFetchData] = useState("");
  const { BaseURL } = useContext(URLstateContext);
  const [vdolist, setVdoList] = useState('');
  const [loadingshow, setloadingshow] = useState(false);
  const [vdoid, setVdoId] = useState('0');
  const [SearchText, setSearchText] = useState('');
  const [pathname, setPathName] = useState('');
  const [FetchDatavdo, setFetchDatavdo] = useState('');
  const [show, setShow] = useState(false);
  // useEffect(() => {
  //   const pathname = window.location.pathname;
  //   const lastSegment = pathname.slice(pathname.lastIndexOf('/') + 1);
  //   const CategoryIdUrlid = lastSegment;
  //   setPathName(CategoryIdUrlid);
  // })
  // useEffect(() => {
  //   setloadingshow(true);
  //   GetMethodData(BaseURL + "GetListVideos", {
  //   }).then((data) => {
  //     if (data.data != null && data.data.length > 0) {
  //       setVdoList(DecryptAESdata(data.data));

  //     }
  //   });

  //   GetPostMethodData(BaseURL + "GetLearnOurFunds", {
  //     "IVOuput": "",
  //     "IIPlaylistID": vdoid,
  //     "IVsearch": SearchText
  //   }).then((data) => {
  //     setloadingshow(false);
  //     if (data.data != null && data.data.length > 0) {
  //       SetFetchData(DecryptAESdata(data.data));
  //       console.log(DecryptAESdata(data.data))
  //       alert('')
  //       setloadingshow(false);
  //     }
  //   });


  // }, [BaseURL, vdoid, SearchText]);

  // const handleChange = (event) => {
  //   setloadingshow(true);
  //   setVdoId(event)
  //   GetPostMethodData(BaseURL + "GetLearnOurFunds", {
  //     "IVOuput": "",
  //     "IIPlaylistID": event,
  //     "IVsearch": SearchText
  //   }).then((data) => {
  //     setloadingshow(false);
  //     if (data.data != null && data.data.length > 0) {
  //       SetFetchData(DecryptAESdata(data.data));
  //       console.log(DecryptAESdata(data.data))
  //       setloadingshow(false);
  //     }
  //   }, [BaseURL, SearchText]);
  // }
  // const handleInputChange = (event) => {
  //   let Blogdata = event.target.value;
  //   setSearchText(Blogdata);
  // }
  // const handleChangeAll = () => {
  //   setloadingshow(true);
  //   GetPostMethodData(BaseURL + "GetLearnOurFunds", {
  //     "IVOuput": "",
  //     "IIPlaylistID": vdoid,
  //     "IVsearch": SearchText
  //   }).then((data) => {
  //     setloadingshow(false);
  //     if (data.data != null && data.data.length > 0) {
  //       SetFetchData(DecryptAESdata(data.data));
  //       setloadingshow(false);
  //     }
  //   });
  // }

  // const clickyoutube = (event) => {
  //   setShow(true)
  //   GetPostMethodData(BaseURL + "GetVideoLink", {
  //     "IVsrno": event
  //   }).then((data) => {
  //     setloadingshow(false);
  //     if (data.data != null && data.data.length > 0) {
  //       setFetchDatavdo(DecryptAESdata(data.data));
  //       setloadingshow(false);
  //     }
  //   }, []);
  // }

  // const handleClosePopup = () => {
  //   setShow(false);
  // };
  return (
    <>
      {/* <section className="blog-sc global-blog-sc">
        <Container>
          <Row>
            <Col>
              <ul className="navigator-arrow">
                <li><a href="/"><i class="fa fa-home" aria-hidden="true"></i></a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                {window.location.pathname != "/Communication-Center" ? <li>{pathname.replace('-', ' ')}</li> : ''}
              </ul>
            </Col>
          </Row>
        </Container>
        <Container>
          <Row>
            <Col sm={12}>
              <div className="section-header">
                <h2>
                  View Videos
                </h2>
                {(FetchData.length === 0) ? <h5 className="errormsgComNew">No Data Available</h5> : ''}

              </div>


            </Col>

          
            <Container>
              <Col sm={12}>
                <Row>
                
                  <div className='ourFund-sch-prod'>
                    <div className='ourFund-button'>
                     
                      {vdolist &&
                        vdolist.map(({ Name, PlaylistID }) =>
                          PlaylistID == vdoid ? (
                            <>
                              <button
                                className="active"
                                onClick={(event) => handleChange(PlaylistID)}
                                value={PlaylistID}
                              >
                                {Name}
                              </button>
                            </>
                          ) : (

                            <button
                              className=" cursorpointer"
                              onClick={(event) => handleChange(PlaylistID)}
                              value={PlaylistID}
                            >
                              {Name}
                            </button>

                          )
                        )}
                    </div>

                    <div className="form-group-container mb-0">
                      <div className="form-group search-input mb-0">

                        <input type="text" className='ourFund-product' name="SearchBlogs" onChange={handleInputChange} id="SearchBlogs" placeholder="Search..." />
                      </div>
                    </div>
                  </div>
                 


                  <div className="fund-container">
                 
                    {FetchData &&
                      FetchData.map(
                        ({ heading, caption,ThumbnailImage,srno }) => (
                          <div className="fund-inner zoom">
                            <h3>{heading}</h3>
                            <span onClick={(event) => clickyoutube(srno)}>
                              <img src={ThumbnailImage}></img>
                             
                            </span>
                            <p>{caption}</p>
                          </div>
                        )
                      )}
                       {(FetchData === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''}
              {FetchDatavdo &&
                FetchDatavdo.map(
                  ({ heading, embeddedlink }) => (
                    <Modal show={show} className="modal modal-teams">
                      <Modal.Body id="modal_info">
                        <div className="btnDiv">
                          <div className="" onClick={handleClosePopup}>
                            <AiFillCloseCircle className="btncl" />
                          </div>
                        </div>
                        <div className="youtubepopup">
                          <p>{heading}</p>
                          <div>
                          <iframe className="iframe-vdo"
                            src={embeddedlink}
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen
                          ></iframe>
                          </div>
                        </div>
                      </Modal.Body>
                    </Modal>
                  )
                )}

                    {loadingshow ? <div className="textcentervertex">

                      <img src={animation} alt="Loading" />
                      <div className="model_popup">Please Wait...</div>
                    </div> : ""
                    }

                  </div>
 
                </Row>
              </Col>

            </Container>
         
          </Row>
        </Container>
      </section> */}


    </>
  );
}

export default OurFundInner